import React, { useEffect, useState } from 'react';

// Utils
import { cloneDeep, isNil } from 'lodash';
import { useAppContext } from '../../../store/AppContext';

// Components
import FlashMessage from '../../molecules/FlashMessage/FlashMessage';

import styles from './PopNotification.module.scss';
import cn from '../../../utils/cn';

function PopNotification() {
  const [{ notifications }, stateDispatch] = useAppContext();
  const [list, setList] = useState(notifications);

  useEffect(() => {
    setList(cloneDeep(notifications));
  }, [notifications]);

  const handleDeleteToast = (id) => {
    const listItemIndex = list?.findIndex((item) => item.id === id);
    const notificationsItemIndex = notifications?.findIndex((item) => item.id === id);

    if (!isNil(listItemIndex) && !isNil(notificationsItemIndex)) {
      stateDispatch({
        type: 'SET_POP_NOTIF',
        payload: cloneDeep(notifications)?.filter((_, index) => index !== notificationsItemIndex) || [],
      });
      setList((prev) => prev.filter((_, index) => index !== listItemIndex));
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (notifications?.length && list?.length) {
        handleDeleteToast(notifications[0].id);
      }
    }, 4000);

    return () => { clearInterval(interval); };
  }, [list]);

  return (
    <div className={cn([styles.container, 'd-flex d-col a-end'])}>
      {list?.map(({ id, message, color }, index) => (
        <button
          key={index}
          type="button"
          onClick={() => handleDeleteToast(id)}
          className={cn([styles.notification, 'm-b-10'])}
        >
          <FlashMessage
            message={message}
            color={color || 'success'}
            isPopNotif
          />
        </button>
      ))}
    </div>
  );
}

PopNotification.propTypes = {};

export default PopNotification;
